import { QueryClient } from '@tanstack/react-query';
import type { OrderListQuery, ProductListQuery, StatsQuery } from '@kon/shared';
import { ApiError } from './api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status < 500) return false;
        return failureCount < 1;
      },
    },
  },
});

export const queryKeys = {
  products: (query: Partial<ProductListQuery>) => ['admin', 'products', query] as const,
  product: (id: string) => ['admin', 'product', id] as const,
  orders: (query: Partial<OrderListQuery>) => ['admin', 'orders', query] as const,
  order: (id: string) => ['admin', 'order', id] as const,
  stats: (query: StatsQuery) => ['admin', 'stats', query] as const,
};
